var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"flat":""}},[_c('BaseCardBody',[_c('h3',{staticClass:"text-sm"},[_vm._v("Google Ads: User List")]),_c('p',{staticClass:"text-xs text-gray-500"},[_vm._v(" "+_vm._s(_vm.gaUserList.name)+" ")]),_c('p',{staticClass:"text-xs text-gray-500 mt-1"},[_vm._v("Customer: "+_vm._s(_vm.customerName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }